import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { PHONE_TEL, WHATSAPP_LINK } from "../lib/constants";

export const FloatingButtons = () => {
    return (
        <>
            <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat on WhatsApp"
                data-testid="floating-whatsapp-btn"
                className="fixed bottom-6 right-6 z-40 bg-[#25D366] text-white p-4 rounded-full shadow-[0_8px_30px_rgba(37,211,102,0.35)] hover:scale-110 active:scale-95 transition-transform duration-200 flex items-center justify-center"
            >
                <MessageCircle size={22} strokeWidth={2.2} />
                <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping -z-10" />
            </a>
            <a
                href={`tel:${PHONE_TEL}`}
                aria-label="Call Raj Graphics"
                data-testid="floating-call-btn"
                className="fixed bottom-6 left-6 z-40 bg-zinc-900 border border-white/10 text-white p-4 rounded-full hover:bg-zinc-800 hover:border-gold/40 hover:text-gold transition-colors duration-200 flex items-center justify-center"
            >
                <Phone size={20} strokeWidth={2.2} />
            </a>
        </>
    );
};

export default FloatingButtons;
